import { createGlobalStyle } from 'styled-components';
import { media } from 'helpers/breakpoints';

export const GlobalStyles = createGlobalStyle<{ cdnUrl?: string }>`
  html {
    line-height: 1.15;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    box-sizing: border-box;
    overflow-y: scroll;
    min-height: 100vh;
    text-size-adjust: 100%;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    background-color: ${({ theme }) => theme.colors.OFFWHITE};
    scrollbar-gutter: stable;
  }

  *, *:before, *:after {
   box-sizing: inherit;
  }

  * {
    font-family: 'Lato', sans-serif;
  }
  
  body {
    margin: 0;
  }

  article,
  aside,
  footer,
  header,
  nav,
  section {
    display: block;
  }
  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }
  figcaption,
  figure,
  main {
    display: block;
  }
  figure {
    margin: 1em 40px;
  }
  hr {
    box-sizing: content-box;
    height: 2px;
    overflow: visible;
    border: none;
    background: ${({ theme }) => theme.colors.GREY_LIGHT};
  }
  pre {
    font-family: monospace, monospace;
    font-size: 1em;
  }
  a {
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.BLUE};
  }
  abbr[title] {
    border-bottom: none;
    text-decoration: underline;
    text-decoration: underline dotted;
  }
  b,
  strong {
    font-weight: inherit;
  }
  b,
  strong {
    font-weight: bolder;
  }
  code,
  kbd,
  samp {
    font-family: monospace, monospace;
    font-size: 1em;
  }
  dfn {
    font-style: italic;
  }
  mark {
    background-color: #ff0;
    color: ${({ theme }) => theme.colors.BLACK};
  }
  small {
    font-size: 80%;
  }
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  audio,
  video {
    display: inline-block;
  }
  audio:not([controls]) {
    display: none;
    height: 0;
  }
  img {
    border-style: none;
  }
  svg:not(:root) {
    overflow: hidden;
  }
  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: sans-serif;
    font-size: 100%;
    line-height: 1.15;
    margin: 0;
  }
  button,
  input {
    overflow: visible;
  }
  button,
  select {
    text-transform: none;
  }
  button,
  html [type='button'],
  [type='reset'],
  [type='submit'] {
    -webkit-appearance: button;
  }
  button {
    border: 0;
  }
  button::-moz-focus-inner,
  [type='button']::-moz-focus-inner,
  [type='reset']::-moz-focus-inner,
  [type='submit']::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }
  button:-moz-focusring,
  [type='button']:-moz-focusring,
  [type='reset']:-moz-focusring,
  [type='submit']:-moz-focusring {
    outline: 1px dotted ButtonText;
  }
  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }
  legend {
    box-sizing: border-box;
    color: inherit;
    display: table;
    max-width: 100%;
    padding: 0; /* 3 */
    white-space: normal;
  }
  progress {
    display: inline-block;
    vertical-align: baseline;
  }
  textarea {
    overflow: auto;
  }
  [type='checkbox'],
  [type='radio'] {
    box-sizing: border-box;
    padding: 0;
  }
  [type='number']::-webkit-inner-spin-button,
  [type='number']::-webkit-outer-spin-button {
    height: auto;
  }
  [type='search'] {
    -webkit-appearance: textfield;
    outline-offset: -2px;
  }
  [type='search']::-webkit-search-cancel-button,
  [type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit;
  }
  details,
  menu {
    display: block;
  }
  summary {
    display: list-item;
  }
  canvas {
    display: inline-block;
  }
  template {
    display: none;
  }
  [hidden] {
    display: none;
  }
  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }
  ::selection {
    background: ${({ theme }) => theme.colors.GREY_DARKER};
    color: ${({ theme }) => theme.colors.WHITE};
  }
  ::-moz-selection {
    background: ${({ theme }) => theme.colors.GREY_DARKER};
    color: ${({ theme }) => theme.colors.WHITE};
  }
  body,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  blockquote,
  pre,
  dl,
  dd,
  ol,
  ul,
  form,
  fieldset,
  legend,
  figure,
  table,
  th,
  td,
  caption,
  hr {
    margin: 0;
    padding: 0;
    color: ${({ theme }) => theme.colors.GREY_DARKER}
  }
  p {
    margin: 0;
    padding: 0;
    color: ${({ theme }) => theme.colors.GREY_DARK}
  }
  abbr[title],
  dfn[title] {
    cursor: help;
  }
  img {
    display: inline-block;
    vertical-align: middle;
    max-width: 100%;
    height: auto;
  }
  ul,
  ol {
    list-style: none;
    margin: 0;
    padding: 0;
  }

 button,
 input,
 optgroup,
 select,
 textarea,
 * {
    font-family: 'Lato', sans-serif;
  }

  button {
    background-color: none;
    background: none;
  }

  .grecaptcha-badge {
    visibility: hidden;
    display: none;
  }

  svg {
    vertical-align: middle;
  }

  /* Chat test overrides */
  @media screen and (max-width: 39.9375em) {
    #g .gg-chat-bubble {
      &.gg-app {
        bottom: 60px !important;
      }
    }
  }

  // for GO anti-flicker snippet
  // see: https://support.google.com/optimize/answer/7100284
  .async-hide { opacity: 0 !important}

  .common-margin-bottom {
    margin-bottom: ${({ theme }) => theme.spacing.S8};

    ${media.large} {
      margin-bottom: ${({ theme }) => theme.spacing.M16};
    }
  }
  
  .text-center {
      text-align:center;
  }

  // Override smooth scroll to auto (instant) if user prefers reduced motion
  @media (prefers-reduced-motion: reduce) {
      html {
          scroll-behavior: auto;
      }
  }

  /*
  Improved screen reader only CSS class

  @author Gaël Poupard
  @note Based on Yahoo!'s technique
  @author Thierry Koblentz
  @see https://www.cssmojo.com/hide-content-from-sighted-users/
  * 1.
  @note \`clip\` is deprecated but works everywhere
  @see https://developer.mozilla.org/en-US/docs/Web/CSS/clip
  * 2.
  @note \`clip-path\` is the future-proof version, but not very well supported yet
  @see https: //developer.mozilla.org/en-US/docs/Web/CSS/clip-path
  @see http: //caniuse.com/#search=clip-path
  @author Yvain Liechti
  @see https://twitter.com/ryuran78/status/778943389819604992
  * 3.
  @note preventing text to be condensed
  author J. Renée Beach
  @see https: //medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
  @note Drupal 8 goes with word-wrap: normal instead
  @see https: //www.drupal.org/node/2045151
  @see http://cgit.drupalcode.org/drupal/commit/?id=5b847ea
  * 4.
  @note !important is important
  @note Obviously you wanna hide something
  @author Harry Roberts
  @see https://csswizardry.com/2016/05/the-importance-of-important/
  */

.sr-only {
    border: 0 !important;
    clip: rect(1px, 1px, 1px, 1px) !important; /* 1 */
    -webkit-clip-path: inset(50%) !important;
    clip-path: inset(50%) !important; /* 2 */
    height: 1px !important;
    margin: -1px !important;
    overflow: hidden !important;
    padding: 0 !important;
    position: absolute !important;
    width: 1px !important;
    white-space: nowrap !important; /* 3 */
}
`;
